import React, { FunctionComponent, useState } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import ImpersonationModal from '~/components/ImpersonationModal/ImpersonationModal';
import Login from './components/Login/Login';
import { Register } from './components/Register/Register';
import { ForgotPassword } from './components/ForgotPassword/ForgotPassword';
import { ResetPassword } from './components/ResetPassword/ResetPassword';
import { SignWithLink } from './components/SignWithLink/SignWithLink';
import LoginByEmail from './components/LoginByEmail/LoginByEmail';
import AuthLayout from './layout/AuthLayout';

/** Ekrany /auth w jednej ramce (wstęgi i nagłówek nie montują się od nowa przy zmianie ekranu). */
const Auth: FunctionComponent = () => {
  const location = useLocation();
  const [impersonateOpen, setImpersonateOpen] = useState(
    () => new URLSearchParams(location.search).get('impersonate') === 'true'
  );

  return (
    <>
      <AuthLayout>
        <Switch>
          <Route exact path="/auth/forgot-password/:email?" component={ForgotPassword} />
          <Route exact path="/auth/login" component={Login} />
          <Route exact path="/auth/register" component={Register} />
          <Route exact path="/auth/reset-password" component={ResetPassword} />
          <Route exact path="/auth/sign-with-link" component={SignWithLink} />
          <Route exact path="/auth/login-by-link" component={LoginByEmail} />
          <Redirect from="/" exact to="/auth/login" />
          <Redirect from="/auth" exact to="/auth/login" />
        </Switch>
      </AuthLayout>
      <ImpersonationModal open={impersonateOpen} onClose={() => setImpersonateOpen(false)} />
    </>
  );
};

export default Auth;
